<script setup>
import { ref, onMounted, nextTick } from 'vue'
import LockLogo from '@/components/PhoneOtpLock.vue'
import { useRouter } from 'vue-router';



import { useSubscriberStore } from '@/stores/subscriber';
import { verifyOtpForRegistration, requestOtpForRegistration } from '@/api/signup';
import { useAdminStore } from '@/stores/admin';

const digits = Array(5).fill('').map(() => ref(''))
const inputs = Array(5).fill(null).map(() => ref(null))

const showSubmitionAnimation = ref(false)
const disabledInputs = ref(false)
const showError = ref(false)

const resendCooldown = ref(60)
const resendDisabled = ref(false)
const showResentMessage = ref(false)

onMounted(() => {

  if (!subscriberStore.phone || subscriberStore.phone.trim() === '') {
    router.push('/');
    return;
  }
  nextTick(() => {
    inputs[0]?.focus()
  })
})

const handleInput = (e, index) => {
  console.log('heheh :>> ');

  const value = e.target.value.replace(/\D/g, '')
  console.log('index + " " + inputs.length + " " + index < inputs.length - 1:>> ', index + " " + inputs.length + " " + index < inputs.length - 1);
  if (value) {
    digits[index].value = value[0]

    if (index < inputs.length - 1) {
      inputs[index + 1]?.focus()
    } else {

      console.log('presubmit :>> ');

      if (digits.every(d => d.value !== '')) {
        submitCode()
      }
    }
    showError.value = false
  } else {
    digits[index].value = ''
  }
}

const handleKeyDown = (e, index) => {
  console.log('HOHO :>> ');
  if (e.key === 'Backspace' && !digits[index].value && index > 0) {
    inputs[index - 1]?.focus()
  }
}



const subscriberStore = useSubscriberStore();

const submitCode = async () => {
  const code = digits.map(d => d.value).join('');
  toggleSubmitionAnimation(true);

  try {
    const payload = {
      ...subscriberStore.$state,
      code,
      wilaya: subscriberStore.wilaya.name,
    };

    const response = await verifyOtpForRegistration(payload);

    if (response.data.success) {
      toggleSubmitionAnimation(false);
      showSuccessModal(true);
      localStorage.removeItem('auth_token');
      subscriberStore.$reset();
      let user = response.data.user;
      let token = response.data.token;
      let subscription = response.data.subscription;
      subscriberStore.setAuthData({ token, user, subscription });



    } else {
      toggleSubmitionAnimation(false);
      toggleSubmitionError(true);

    }

  } catch (error) {
    toggleSubmitionAnimation(false);
    toggleSubmitionError(true);
    console.error('Erreur vérification OTP :', error);
  }
};

const toggleSubmitionAnimation = (active) => {
  showSubmitionAnimation.value = active
  disabledInputs.value = active
}

const toggleSubmitionError = (active) => {
  showError.value = active
}

const resetCode = () => {
  digits.forEach(d => d.value = '')
  showError.value = false
  inputs[0]?.focus()
}

const startResendCooldown = async () => {
  resendDisabled.value = true;
  resendCooldown.value = 60;
  showResentMessage.value = true;
  resetCode();

  try {

    const response = await requestOtpForRegistration(subscriberStore.phone);

    if (!response.data.success) {

      resendDisabled.value = false;
      showResentMessage.value = false;
      return;
    }
  } catch (error) {
    console.error('Erreur en renvoyant le code OTP:', error);
    resendDisabled.value = false;
    showResentMessage.value = false;
    return;
  }

  const interval = setInterval(() => {
    resendCooldown.value--;
    if (resendCooldown.value <= 0) {
      clearInterval(interval);
      resendDisabled.value = false;
      showResentMessage.value = false;
    }
  }, 1000);
};


const successSubmition = ref(false);
const router = useRouter();


const showSuccessModal = (show) => {
  successSubmition.value = show;
  toggleSubmitionAnimation(!show);
  if (!show) {


    router.push('edit');
  }
}
</script>

<template>
  <div class="w-full h-full flex justify-center items-center relative">
    <!-- Success Modal -->
    <div v-if="successSubmition" class="absolute inset-0 bg-black/50 flex justify-center items-center z-50">
      <div class="bg-white rounded-2xl shadow-xl w-11/12 max-w-sm p-6 flex flex-col items-center animate-fade-in">
        <!-- Success Icon -->
        <div class="w-16 h-16 rounded-full bg-green-100 flex justify-center items-center mb-4">
          <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <!-- Title -->
        <h2 class="text-xl font-semibold text-gray-800 mb-2">
          {{ $t('phoneConfirmation.successTitle') }}
        </h2>
        <p class="text-gray-600 text-center mb-4">
          {{ $t('phoneConfirmation.successMessage') }}
        </p>

        <!-- Close Button -->
        <button @click="showSuccessModal(false)"
          class="bg-green-600 hover:bg-green-700 text-white font-medium px-5 py-2 rounded-lg shadow transition duration-200">
          {{ $t('phoneConfirmation.go_to_profile') }}
        </button>
      </div>
    </div>

    <!-- Main Content -->
    <div class="w-full lg:w-1/2 h-full flex flex-col justify-center items-center">
      <!-- Lock Logo -->
      <div class="w-full h-1/3 flex justify-center items-center">
        <LockLogo />
      </div>

      <!-- Form Content -->
      <div class="h-2/3 flex flex-col items-center justify-start mt-2 space-y-2">
        <!-- Title -->
        <div class="text-lg font-medium">
          {{ $t('phoneConfirmation.confirmTitle') }}
        </div>

        <!-- Description -->
        <div class="text-gray-700 text-center w-4/5 lg:w-2/4">
          {{ $t('phoneConfirmation.confirmDescription') }}
        </div>

        <!-- OTP Inputs -->
        <div class="flex justify-center items-center w-full space-x-5 pt-5 px-5 lg:px-0">
          <template v-for="(digit, index) in digits" :key="index">
            <div class="w-1/6 lg:w-1/12">
              <input type="text" maxlength="1" inputmode="numeric" pattern="[0-9]*" :ref="el => inputs[index] = el"
                v-model="digit.value" @input="(e) => handleInput(e, index)" @keydown="(e) => handleKeyDown(e, index)"
                :disabled="disabledInputs" :class="[
                  'w-full rounded-lg outline-none text-center text-lg shadow px-3 py-4 transition duration-200 border',
                  disabledInputs ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                    : 'hover:border-2 focus:border-primary',
                  showError ? 'border-red-300' : 'border-gray-300'
                ]" />
            </div>
          </template>
        </div>

        <!-- Error Message -->
        <div v-if="showError" class="text-red-400 text-sm lg:w-3/4 font-medium w-4/5 text-center">
          {{ $t('phoneConfirmation.errorMessage') }}
        </div>

        <!-- Resent Code Message -->
        <div v-if="showResentMessage" class="text-primary text-sm font-medium text-center">
          {{ $t('phoneConfirmation.resentMessage') }}
        </div>

        <!-- Resend Button -->
        <div class="pt-2">
          <button
            class="text-primary font-medium transition duration-200 hover:underline disabled:text-gray-400 disabled:cursor-not-allowed"
            @click="startResendCooldown" :disabled="resendDisabled">
            <span v-if="!resendDisabled">
              {{ $t('phoneConfirmation.resendCode') }}
            </span>
            <span v-else>
              {{ $t('phoneConfirmation.resendIn', { seconds: resendCooldown }) }}
            </span>
          </button>
        </div>

        <!-- Submit / Loading -->
        <div class="w-full flex justify-center items-center pt-5">
          <!-- Submit button -->
          <div :class="[
            showSubmitionAnimation ? 'hidden opacity-0' : 'block opacity-100',
            'bg-primary w-1/2 lg:w-1/3 text-white text-center rounded py-2 px-3 hover:bg-secondary hover:cursor-pointer transition duration-200'
          ]" @click="submitCode">
            {{ $t('phoneConfirmation.confirmButton') }}
          </div>

          <!-- Loading animation -->
          <div :class="[
            !showSubmitionAnimation ? 'hidden' : 'flex',
            'justify-center items-center space-x-2 mt-4'
          ]">
            <span class="w-3 h-3 bg-primary rounded-full animate-bounce-wave delay-0"></span>
            <span class="w-3 h-3 bg-primary rounded-full animate-bounce-wave delay-150"></span>
            <span class="w-3 h-3 bg-primary rounded-full animate-bounce-wave delay-300"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
@keyframes fade-in {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.animate-fade-in {
  animation: fade-in 0.3s ease-out;
}

@keyframes bounce-wave {

  0%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-20px);
  }
}

.animate-bounce-wave {
  animation: bounce-wave 1.2s infinite ease-in-out;
}

.delay-0 {
  animation-delay: 0s;
}

.delay-150 {
  animation-delay: 0.15s;
}

.delay-300 {
  animation-delay: 0.3s;
}
</style>
